import {
    useEffect,
    useState,
} from 'react';

import {
    useDispatch,
    useSelector,
} from 'react-redux';

import {
  CONFIRM_TYPES,
  DEFAULT_ROW_PER_PAGE,
  DEFAULT_HOMEPAGE_ROW_PER_PAGE,
  ROW_PER_PAGE_OPTIONS,
  OPERATOR_THEME,
  CU_PHAP_DANG_KY_GOI_CUOC,
} from 'src/utils/constants';

import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet";

import { Goicuoc5gAction } from 'src/actions/goicuoc5g.action';

import numeral from 'numeral';

import DangKyGoiCuocDialog from './DangKyGoiCuocDialog';

import goiCuocHeadMobifone from "../../assets/images/goiCuocHeadMobifone.svg";
import goiCuocHeadVinaphone from "../../assets/images/goiCuocHeadVinaphone.svg";
import goiCuocHeadViettel from "../../assets/images/goiCuocHeadViettel.svg";
import goiCuocHeadHot from "../../assets/images/goiCuocHeadHot.svg";

const TheHomepageGoicuoc5gOne = ({ product }) => {
    const dispatch = useDispatch()
    const { operator, itemId } = useParams();
    const { homepageGoicuoc5gSelected } = useSelector(state => state.goicuoc5g)
    const [open, setOpen] = useState(false);
    const { isLoading } = useSelector(state => state.app);

    const [name, setName] = useState("");
    const [price, setPrice] = useState(0);
    const [price_new, setPriceNew] = useState(0);
    const [number_type, setNumberType] = useState("-99");
    const [loai_goi_cuoc, setLoaiGoiCuoc] = useState({});
    const [loai_goi_cuoc1, setLoaiGoiCuoc1] = useState([]);
    const [time_by_day, setTimeByDay] = useState(0);
    const [tam_dung, setTamDung] = useState("-99");
    const [short_description, setShortDescription] = useState("");
    const [description, setDescription] = useState("");

    const operatorTheme = typeof OPERATOR_THEME[operator] !== 'undefined' ? OPERATOR_THEME[operator] : null;

    useEffect(() => {
        console.log(itemId);
        dispatch(Goicuoc5gAction.homepageFindOne(itemId));
    }, [itemId])

    useEffect(() => {
        console.log(homepageGoicuoc5gSelected);

        setName('')
        setPrice(0)
        setPriceNew(0)
        setNumberType('99')
        setTimeByDay(0)
        setTamDung('-99')
        setShortDescription('')
        setDescription('')
        setLoaiGoiCuoc({})
        setLoaiGoiCuoc1([])

        if (homepageGoicuoc5gSelected) {
            setName(homepageGoicuoc5gSelected.name)
            setPrice(homepageGoicuoc5gSelected.price)
            setPriceNew(homepageGoicuoc5gSelected.price_new)
            setNumberType(homepageGoicuoc5gSelected.number_type)
            setTimeByDay(homepageGoicuoc5gSelected.time_by_day)
            setTamDung(homepageGoicuoc5gSelected.tam_dung.toString())
            setShortDescription(homepageGoicuoc5gSelected.short_description)
            setDescription(homepageGoicuoc5gSelected.description)
            setLoaiGoiCuoc1(homepageGoicuoc5gSelected.types);

            setLoaiGoiCuoc({});

            if (homepageGoicuoc5gSelected.types && Object.keys(homepageGoicuoc5gSelected.types).length > 0) {
                let inputLoaiGoiCuoc = {};

                Object.entries(homepageGoicuoc5gSelected.types).forEach(([key, value]) => {
                    inputLoaiGoiCuoc[value.loai_goi_cuoc] = 1;
                });

                setLoaiGoiCuoc(inputLoaiGoiCuoc);
            }
        }
    }, [homepageGoicuoc5gSelected])

    const dangKy = (id) => {
      dispatch(Goicuoc5gAction.homepageFindOne(id));
      setOpen(true);
    };

    const handleClose = () => {
      setOpen(false);
    };

    return (<>
        <Helmet>
            <title>Gói cước {name.toUpperCase()} | Gói cước - Di Dong Telecom</title>

            <style>{`
                .goicuoc5g-one-container {
                  display: flex;
                }

                .goicuoc5g-item.list_Sim {
                  width: 258.87px !important;
                  min-width: 258.87px !important;
                  height: auto !important;
                  padding-bottom: 10px !important;
                  margin-top: 0 !important;
                }

                .goicuoc5g-item.list_Sim p.list_Sim_1 {
                  font-size: 25px !important;
                  line-height: 55px !important;
                }

                .goicuoc5g-item.list_Sim .list_Sim_23 {
                  height: auto !important;
                }

                .goicuoc5g-item.list_Sim .list_Sim_23 p {
                  font-size: 18px !important;
                }

                .goicuoc5g-item.list_Sim .sim_hot {
                  width: 55px !important;
                }

                .goicuoc5g-item .right {
                  float: unset !important;
                  margin: auto !important;
                }

                .goicuoc5g-item .right .btn1 {
                  width: 100% !important;
                  margin: 0 !important;
                  font-size: 14px !important;
                }

                .goicuoc5g-content {
                  width: 100% !important;
                  margin-left: 30px !important;
                }

                @media (max-width: 768px) {
                  .goicuoc5g-one-container {
                    display: block !important;
                  }

                  .goicuoc5g-content {
                    margin-top: 20px !important;
                    margin-left: 0 !important;
                  }
                }
            `}</style>
        </Helmet>

        {isLoading && <div className='loading'></div>}

        {!isLoading && <div className='goicuoc5g-one-container'>
          <div class={`goicuoc5g-item ${operator.toUpperCase()} list_Sim`}>
            {tam_dung == 1 && <div class="pause-stamp">TẠM DỪNG</div>}

            <p class="list_Sim_1 ng-binding">{name}</p>
            <img class="img_cong" src={operator.toUpperCase() == 'MOBIFONE' ? goiCuocHeadMobifone : (operator.toUpperCase() == 'VINAPHONE' ? goiCuocHeadVinaphone : goiCuocHeadViettel)} alt="" />
            {loai_goi_cuoc1 && loai_goi_cuoc1?.some(type => type.loai_goi_cuoc === 'goi_hot') && (
              <img class="sim_hot ng-scope" src={goiCuocHeadHot} alt="" />
            )}
            <div class="list_Sim_23">
              <p class="boder_dotted ng-binding">{short_description}</p>
              <p class="boder_dotted ng-binding">
                {(Number(price_new) > 0 && Number(price_new) < Number(price)) ? (
                  <div>
                    <span style={{ color: 'red', fontWeight: 'bold' }}>
                      {numeral(price_new).format('0,0')}₫
                    </span>
                    <br></br>
                    <span className='price-old' style={{ textDecoration: 'line-through', color: '#888' }}>
                      {numeral(price).format('0,0')}₫
                    </span>
                  </div>
                ) : (
                  <div>
                    <span style={{ fontWeight: 'bold' }}>
                      {numeral(price).format('0,0')}₫
                    </span>
                  </div>
                )}
              </p>
              <p class="ng-binding">{time_by_day} ngày</p>
            </div>
            <div class="row">
              <div class={`right ${tam_dung == 1 ? "disable" : ''}`}>
                <label style={{borderColor: typeof operatorTheme['primary'] !== 'undefined' ? operatorTheme['primary'] : '#000000', background: typeof operatorTheme['primary'] !== 'undefined' ? operatorTheme['primary'] : '#000000'}} class="btn1" id="btn_left1" onClick={() => dangKy(itemId)}>Đăng ký</label>
              </div>
            </div>
          </div>

          <div className='goicuoc5g-content media-content' dangerouslySetInnerHTML={{ __html: description }} />

          <DangKyGoiCuocDialog open={open} handleClose={handleClose} type={"EDIT"} />
        </div>}
    </>);
};

export default TheHomepageGoicuoc5gOne;